import React, { useState } from "react";
import GenericButton from "../../common/genericButton";
import GenericInput from "../../common/GenericInput";
import GenericModal from "../../common/genericModal";
import styles from "./internaltransfer.module.scss";
import DropDown from "../../common/Dropdown/DropDown";

const InternalTransfer = ({ isOpen, toggle }) => {
  const [selected, setSelected] = useState("Dollar");
  const options = ["euro", "Dollar", "euro", "Dollar", "euro"];
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.mainheading}>Internal Transfer</div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label={"Email"}
            placeholder="Enter Email address "
            type="text"
            withRightIcon={false}
            name="email"
            onChange={changeHandler}
            icon={"/assets/icons-email.svg"}
          />
        </div>
        <div className={styles.label}> &nbsp;&nbsp;&nbsp;Select Currency</div>
        <div className={styles.fieldWrapper}>
          <DropDown
            selected={selected}
            setSelected={setSelected}
            options={options}
          />
        </div>
        <div className={styles.fieldWrapper}>
          <GenericInput
            label={"Enter Amount"}
            placeholder="Enter Amount"
            type="text"
            withRightIcon={false}
            name="email"
            onChange={changeHandler}
            icon={"/assets/amount.png"}
          />
        </div>

        <div className={styles.fieldWrapper}>
          <div className={styles.footerdiv}>
            <div className={styles.row1}>
              <div className={styles.lefttext}>Transaction Fee:</div>
              <div className={styles.righttext}>0.0 &nbsp;&nbsp; EURO</div>
            </div>
            <div className={styles.row2}>
              <div className={styles.lefttext}>Estimated Balance:</div>
              <div className={styles.righttext}>0.0 &nbsp;&nbsp; EURO</div>
            </div>
          </div>
        </div>

        <div className={styles.buttonWrapper}>
          <GenericButton title={"Submit"} />
        </div>
      </GenericModal>
    </>
  );
};

export default InternalTransfer;
